import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b29c49e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalDisplayTarget",
  class: "display-container"
}
const _hoisted_2 = {
  ref: "modalTargetLandscape",
  class: "description-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  target: "”_blank”",
  href: "https://asknicely.zendesk.com/hc/en-us/articles/4405787070612-Choose-your-metric-NPS-vs-CSAT-vs-5-Star-"
}, "customer ratings article", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiMetricSelect = _resolveComponent("MultiMetricSelect")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_InfoModal = _resolveComponent("InfoModal")!
  const _component_Portal = _resolveComponent("Portal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "modalTargetPortrait",
      class: "nps-number"
    }, _toDisplayString(_ctx.formatScore(
                    _ctx.score,
                    _ctx.isFiveScoreQuestionType(_ctx.scoreType),
                    _ctx.$companyVars.has_display_csat_as_percentage,
                    _ctx.scoreType ?? 'nps',
                    _ctx.$companyVars?.decimals
                )), 513),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        (_ctx.customLabel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.customLabel), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_MultiMetricSelect, { "disable-select": _ctx.disableMetricPicker }, null, 8, ["disable-select"]),
        _hoisted_4,
        (_ctx.month)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("End of " + _toDisplayString(_ctx.monthName), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode("LAST "),
              (_ctx.scoreDays === '1')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "24 Hours"))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.scoreDays) + " Days", 1))
            ], 64))
      ]),
      _createElementVNode("span", {
        class: "question-icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalOpen()))
      }, [
        _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faQuestionCircle }, null, 8, ["icon"])
      ])
    ], 512),
    (_ctx.showingNPSFeedback)
      ? (_openBlock(), _createBlock(_component_Portal, {
          key: 0,
          to: 'shadow-overlay-destination',
          target: _ctx.$refs.modalDisplayTarget
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InfoModal, {
              show: "",
              "x-adjust": 30,
              title: _ctx.helpTitle,
              "report-card-popup": _ctx.reportCardPopupStyle,
              "portrait-target": _ctx.$refs.modalDisplayTarget,
              "landscape-target": _ctx.$refs.modalTargetLandscape,
              onClose: _ctx.modalClose
            }, {
              default: _withCtx(() => [
                (_ctx.helpText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.helpText), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "This is your customer rating over the past 30 days which determines if you have achieved the monthly goal at the end of the month.")),
                _createTextVNode(" Please see the "),
                _hoisted_9,
                _createTextVNode(" for more info on how this number is calculated. ")
              ], undefined, true),
              _: 1
            }, 8, ["title", "report-card-popup", "portrait-target", "landscape-target", "onClose"])
          ], undefined, true),
          _: 1
        }, 8, ["target"]))
      : _createCommentVNode("", true)
  ], 512))
}